class DRGWiesService {

  constructor($http, $rootScope) {
    if ($rootScope && $rootScope.globals)
      $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  getWies(hid) {
    return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/model.wiestarget/hid/' + hid);
  }

  putWies(wiesId, data) {
    return this.$http({
      method: 'PUT',
      url: WEBSERVICEURL + '/dataagility/api/model.wiestarget/' + wiesId,
      data: data,
      headers: { 'Content-Type': 'application/json' }
    })
  }

  postWies(data) {
    return this.$http.post(WEBSERVICEURL + '/dataagility/api/model.wiestarget', data);
  }

}

Object.defineProperty(
    Object.prototype,
    'renameProperty',
    {
        writable : false, // Cannot alter this property
        enumerable : false, // Will not show up in a for-in loop.
        configurable : false, // Cannot be deleted via the delete operator
        value : function (oldName, newName) {
            // Check for the old property name to
            // avoid a ReferenceError in strict mode.
            if (this.hasOwnProperty(oldName)) {
                this[newName] = this[oldName];
                delete this[oldName];
            }
            return this;
        }
    }
);

class EpisodevalueController {
  constructor($http, $scope, CONST, $location, $rootScope, FunctionService) {

    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;

    this.episodeValue = '';
    this.name = '';
    this.options = {
      removeChromeAutoComplete: true
    };
    this.form = "wiesTargets";
    this.yearOptions = [];
    this.year = {
      selectedYear: null
    };
    this.model = {};
    this.yearData = {};
    this.yearDataCopy = {};
    this.yearAdded = false;

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
        $scope.vm.name = $scope.vm.episodeValue + ' Targets';
      }
    );

    new DRGWiesService($http, $scope).getWies(CONST.HOSPITALID)
    .then(

      function successCallback(response) {

        var currentYear = true,
            count = 0;

        // setup Year select and model
        angular.forEach(response.data, function(value, key) {

          var mom = moment(value.month);
          var year = mom.format('YYYY'),
              prevYear = mom.subtract(1, "year").format('YYYY'),
              monthName = mom.format('MMMM').toUpperCase(),
              finYear = year + " - " + prevYear;

          // add year
          if ( key === 0 ) {
            $scope.vm.yearOptions.push(prevYear + " - " + year);
          } else if ( key % 12 === 0 ) {
            count++;
            $scope.vm.yearOptions.push(prevYear + " - " + year);
          }

          // add year and month to object
          if ( typeof($scope.vm.yearData[count]) === 'undefined' ) {

            $scope.vm.yearData[count] = { [monthName]: Object() };

          } else {

            $scope.vm.yearData[count][monthName] = Object();

          }

          $scope.vm.yearData[count][monthName].id = value.id;
          $scope.vm.yearData[count][monthName].month = value.month;
          $scope.vm.yearData[count][monthName].target = value.target;
          $scope.vm.yearData[count][monthName].monthName = value.monthName;
          $scope.vm.yearData[count][monthName].hospitalId = value.hospitalId;

        });

        // select the latest
        $scope.vm.year.selectedYear = $scope.vm.yearOptions[0];

      },
      function errorCallback(response) {
        if (response.status === 401) {
          window.location.replace(window.location.origin + '/login?logout=true');
        }
      }
    );

    this.addWies = addWies;
    this.wiesCallback = wiesCallback;

    function addWies() {
      // add a new blank FY to the model
      $scope.vm.yearAdded = true;
      const oldYear = parseInt($scope.vm.yearOptions[0].substring(0,4)) + 1;
      const newYear = oldYear + 1;
      $scope.vm.yearOptions.unshift( oldYear + " - " + newYear);

      angular.copy($scope.vm.yearData, $scope.vm.yearDataCopy);
      $scope.vm.yearData = {};

      $scope.vm.yearData[0] = {};
      $scope.vm.yearData[0].JULY = Object();
      $scope.vm.yearData[0].JULY.monthName = "JULY";
      $scope.vm.yearData[0].AUGUST = Object();
      $scope.vm.yearData[0].AUGUST.monthName = "AUGUST";
      $scope.vm.yearData[0].SEPTEMBER = Object();
      $scope.vm.yearData[0].SEPTEMBER.monthName = "SEPTEMBER";
      $scope.vm.yearData[0].OCTOBER = Object();
      $scope.vm.yearData[0].OCTOBER.monthName = "OCTOBER";
      $scope.vm.yearData[0].NOVEMBER = Object();
      $scope.vm.yearData[0].NOVEMBER.monthName = "NOVEMBER";
      $scope.vm.yearData[0].DECEMBER = Object();
      $scope.vm.yearData[0].DECEMBER.monthName = "DECEMBER";
      $scope.vm.yearData[0].JANUARY = Object();
      $scope.vm.yearData[0].JANUARY.monthName = "JANUARY";
      $scope.vm.yearData[0].FEBRUARY = Object();
      $scope.vm.yearData[0].FEBRUARY.monthName = "FEBRUARY";
      $scope.vm.yearData[0].MARCH = Object();
      $scope.vm.yearData[0].MARCH.monthName = "MARCH";
      $scope.vm.yearData[0].APRIL = Object();
      $scope.vm.yearData[0].APRIL.monthName = "APRIL";
      $scope.vm.yearData[0].MAY = Object();
      $scope.vm.yearData[0].MAY.monthName = "MAY";
      $scope.vm.yearData[0].JUNE = Object();
      $scope.vm.yearData[0].JUNE.monthName = "JUNE";

      // Bump every FY down one and re-add
      angular.forEach($scope.vm.yearDataCopy, function(value, key) {

        var newKey =  parseInt(key) + 1;
        $scope.vm.yearData[newKey] = value;

      });

      // unset
      $scope.vm.yearDataCopy = {};

      // Select the new FY
      $scope.vm.year.selectedYear = $scope.vm.yearOptions[0];

    }

    function wiesCallback(_newValue, _oldValue) {

      var currentYearData = $scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)];

      if ( currentYearData !== $scope.vm.model ) {
        angular.copy(currentYearData, $scope.vm.model);
      }

      // reset listener and form state
      $scope.vm.form.$setPristine();
      $scope.vm.form.$setValidity();
      $scope.vm.form.$setUntouched();

    }

    this.yearValid = function() {
      return $scope.vm.yearAdded;
    }

    this.checkValid = function() {

      // dis/enable submit button

      if ( $scope.vm.form.$pristine ) {

        return true;

      } else {

        if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {

          return false;

        } else {

          return true;
        }

      }

    }

    this.submitWies = function() {

      var currentYearData = $scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)];

      angular.forEach($scope.vm.model, function(value, key) {

          if (value.target !== currentYearData[value.monthName].target) {

            if (value.id) {

              // existing wies = put
              $scope.putData(value);

            } else {

              // new wies = post
              var year = parseInt($scope.vm.year.selectedYear.substring(0,4));

              if ( ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE'].includes(key) )
                year = parseInt(year)+1;

              var date = moment('' + year + '-' + value.monthName + '-01', 'YYYY-MMMM-DD').format();
              value.month = date;
              value.hospitalId = CONST.HOSPITALID;

              $scope.postData(value,currentYearData);

            }
        }
      });
    }

    $scope.putData = function(data) {

      var wiesId = data.id,
        data = JSON.stringify(data);

      new DRGWiesService($http).putWies(wiesId, data)
        .then(

          function successCallback(response) {

            angular.copy($scope.vm.model,$scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)]);
            $scope.snackBar($scope.vm.episodeValue + ' updated');

          },
          function errorCallback(response) {
            $scope.snackBar('Error saving ' + $scope.vm.episodeValue);
            if (response.status === 401) {
              window.location.replace(window.location.origin + '/login?logout=true');
            }
          });
    }

    $scope.postData = function(data,count) {

      new DRGWiesService($http).postWies(data)
        .then(

          function successCallback(response) {

            // add the ID, so it can be edited
            $scope.vm.model[response.data.data.monthName].id = response.data.data.id;

            angular.copy($scope.vm.model[response.data.data.monthName],$scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)][response.data.data.monthName]);

            if ( data.monthName === 'JUNE' ) {
              $scope.snackBar($scope.vm.episodeValue + ' added');
              $scope.vm.yearAdded = false;
            }

          },
          function errorCallback(response) {
            $scope.snackBar('Database error, or ' + $scope.vm.episodeValue + 'already exists');
            if (response.status === 401) {
              window.location.replace(window.location.origin + '/login?logout=true');
            }
          });

    }

    $scope.snackBar = function(message) {

      // upgrade MDI components
      window.componentHandler.upgradeAllRegistered();

      var snackbarContainer = document.querySelector('#wies__notification');

      var data = {
        message: message,
        timeout: 2000,
        actionHandler: $scope.finaliseCheck,
        actionText: 'test'
      };

      snackbarContainer.MaterialSnackbar.showSnackbar(data);

    }

    this.fields = [
      {
        type: 'lx-input',
        key: 'JULY.target',
        templateOptions: {
          'type': 'number',
          'label': 'July',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'AUGUST.target',
        templateOptions: {
          'type': 'number',
          'label': 'August',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'SEPTEMBER.target',
        templateOptions: {
          'type': 'number',
          'label': 'September',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'OCTOBER.target',
        templateOptions: {
          'type': 'number',
          'label': 'October',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'NOVEMBER.target',
        templateOptions: {
          'type': 'number',
          'label': 'November',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'DECEMBER.target',
        templateOptions: {
          'type': 'number',
          'label': 'December',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'JANUARY.target',
        templateOptions: {
          'type': 'number',
          'label': 'January',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'FEBRUARY.target',
        templateOptions: {
          'type': 'number',
          'label': 'February',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'MARCH.target',
        templateOptions: {
          'type': 'number',
          'label': 'March',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'APRIL.target',
        templateOptions: {
          'type': 'number',
          'label': 'April',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'MAY.target',
        templateOptions: {
          'type': 'number',
          'label': 'May',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'JUNE.target',
        templateOptions: {
          'type': 'number',
          'label': 'June',
          required: true
        }
      }

    ];

  }
}

export default EpisodevalueController;



// WEBPACK FOOTER //
// ./client/app/common/admin/episodevalue/episodevalue.controller.js